import '../CsvJsonInfoPages.scss';


function FuelDelivery() {

    const data = [
        { field: 1, description: 'Fuel Delivery Code (Char)' },
        { field: 2, description: 'Fuel Delivery Description (Char)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Fuel Delivery</h1>
            <p>This file contains the different types of Fuel Delivery coded by CAP.  Fuel delivery is linked in the Derivative file.  <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_CAPFuelDelivery.txt .txt<br />
                LIGHTS_yyyy-mm-dd_CAPFuelDelivery.txt .txt<br />
                HEAVIES_yyyy-mm-dd_CAPFuelDelivery.txt .txt<br />
                BIKES_yyyy-mm-dd_CAPFuelDelivery.txt .txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default FuelDelivery;
